import { VIEW_TO_PATH } from '../../routes';
import { supabase } from '../../supabaseClient';

/* Connexion, navigation « voir en tant que » et ouverture des fenêtres modales. */
export function createSessionActions(deps) {
  const { navigate, profile, session, setForm, setLoginError, setModal, setModalData } = deps;
  const { setTimesheetUserId, setViewAsMemberId } = deps;

  function openModal(type, data = {}, initForm = {}) {
    setModal(type);
    setModalData(data);
    setForm(initForm);
  }

  function closeModal() {
    setModal(null);
    setModalData({});
    setForm({});
  }

  function startViewAs(devId) {
    setViewAsMemberId(devId);
    setTimesheetUserId(devId);
    navigate(VIEW_TO_PATH.timesheets);
  }

  function stopViewAs() {
    setViewAsMemberId(null);
    setTimesheetUserId('me');
    navigate(VIEW_TO_PATH.timeline);
  }

  async function handleLogout() {
    await supabase.auth.signOut();
    navigate(VIEW_TO_PATH.timeline);
  }

  async function handleMicrosoftLogin() {
    setLoginError('');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'azure',
      options: { scopes: 'email' },
    });
    if (error) setLoginError('Connexion Microsoft impossible : ' + error.message);
  }

  // Résout l'utilisateur cible affiché dans Feuilles d'heures.
  // Les non-managers ne voient qu'eux-mêmes ; un manager voit le collaborateur sélectionné.
  function resolveTimesheetUserId(target) {
    if (profile?.role !== 'manager') return session.user.id;
    return !target || target === 'me' ? session.user.id : target;
  }

  return {
    openModal,
    closeModal,
    startViewAs,
    stopViewAs,
    handleLogout,
    handleMicrosoftLogin,
    resolveTimesheetUserId,
  };
}
